// extracted by mini-css-extract-plugin
module.exports = {"root":"ReportModalFilter_root__1_diK","footer":"ReportModalFilter_footer__1kRpO"};